'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class; // Lib


// Utils


// Selectors


// Components


// Measurements Store


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _lodash = require('lodash');

var _point = require('../../../common/maths/geometry/point');

var pointLib = _interopRequireWildcard(_point);

var _rect = require('../../../common/maths/geometry/rect');

var rectLib = _interopRequireWildcard(_rect);

var _lineUtil = require('./lineUtil');

var _elementSelector = require('../elementSelector');

var _lineSelector = require('./lineSelector');

var _lineConstants = require('../../../common/lines/lineConstants');

var _Line = require('./Line');

var _Line2 = _interopRequireDefault(_Line);

var _measurementsSelector = require('../../components/measurements/measurementsSelector');

var _measurementsConnect = require('../../components/measurements/measurementsConnect');

var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO Return only the required measurements (the ones that the line edges require)
var mapMeasurementsStateToProps = function mapMeasurementsStateToProps(connectionsState) {
    return {
        measurements: (0, _measurementsSelector.getMeasurementsMap)(connectionsState)
    };
};

var getUpdatedEdges = function getUpdatedEdges() {
    return (0, _reselect.createSelector)((0, _lineSelector.makeGetLineEdgeDetails)(), _lineSelector.getLineControl, _elementSelector.getElement, function (state, ownProps) {
        return ownProps.offsetDiff;
    }, function (state, ownProps) {
        return ownProps.draggedElementIds;
    }, function (_ref, control, element, offsetDiff, draggedElementIds) {
        var startEdgeOrigin = _ref.startEdgeOrigin,
            startConnectionRect = _ref.startConnectionRect,
            endEdgeOrigin = _ref.endEdgeOrigin,
            endConnectionRect = _ref.endConnectionRect;

        var draggingStart = (0, _lodash.includes)(draggedElementIds, element.getIn(['content', _lineConstants.LINE_EDGE.start, 'elementId']));
        var draggingEnd = (0, _lodash.includes)(draggedElementIds, element.getIn(['content', _lineConstants.LINE_EDGE.end, 'elementId']));

        var translatedStartConnectionRect = draggingStart ? rectLib.translate(offsetDiff, startConnectionRect) : startConnectionRect;
        var translatedEndConnectionRect = draggingEnd ? rectLib.translate(offsetDiff, endConnectionRect) : endConnectionRect;

        var translatedStartEdgeOrigin = draggingStart ? pointLib.translate(offsetDiff, startEdgeOrigin) : startEdgeOrigin;
        var translatedEndEdgeOrigin = draggingEnd ? pointLib.translate(offsetDiff, endEdgeOrigin) : endEdgeOrigin;

        // Find the control point
        var controlPoint = (0, _lineSelector.getControlPosition)({
            start: translatedStartEdgeOrigin,
            end: translatedEndEdgeOrigin,
            control: control
        });

        return (0, _lineUtil.getLinePointsOfInterest)({
            startEdgeOrigin: translatedStartEdgeOrigin,
            startConnectionRect: translatedStartConnectionRect,
            endEdgeOrigin: translatedEndEdgeOrigin,
            endConnectionRect: translatedEndConnectionRect,
            controlPoint: controlPoint
        });
    });
};

var makeMapStateToProps = function makeMapStateToProps() {
    return (0, _reselect.createSelector)(_elementSelector.getElementId, getUpdatedEdges(), _elementSelector.getColourHex, _lineSelector.getLineStartStyle, _lineSelector.getLineEndStyle, function (elementId, _ref2, colorHex, startStyle, endStyle) {
        var start = _ref2.start,
            end = _ref2.end,
            controlPoint = _ref2.controlPoint;
        return {
            elementId: elementId,
            start: start,
            end: end,
            controlPoint: controlPoint,
            colorHex: colorHex,
            startStyle: startStyle,
            endStyle: endStyle
        };
    });
};

var ConnectedLineDragPreview = (_dec = (0, _measurementsConnect2.default)(mapMeasurementsStateToProps), _dec2 = (0, _reactRedux.connect)(makeMapStateToProps), _dec(_class = _dec2(_class = function (_React$Component) {
    _inherits(ConnectedLineDragPreview, _React$Component);

    function ConnectedLineDragPreview() {
        _classCallCheck(this, ConnectedLineDragPreview);

        return _possibleConstructorReturn(this, (ConnectedLineDragPreview.__proto__ || Object.getPrototypeOf(ConnectedLineDragPreview)).apply(this, arguments));
    }

    _createClass(ConnectedLineDragPreview, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_Line2.default, _extends({}, this.props, { isPresentational: true }));
        }
    }]);

    return ConnectedLineDragPreview;
}(_react2.default.Component)) || _class) || _class);


ConnectedLineDragPreview.propTypes = {
    elementId: _propTypes2.default.string.isRequired,
    draggedElementIds: _propTypes2.default.array.isRequired,
    offsetDiff: _propTypes2.default.object
};

exports.default = ConnectedLineDragPreview;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/ConnectedLineDragPreview.js
// module id = 1989
// module chunks = 0